import {Component, Input, Output, EventEmitter} from '@angular/core';
import { ThingSequenceFeatureInterface } from '@app/app/shared/interfaces/thing/thing-sequence-feature.interface';
import { UpdatedSequenceBlockInterface } from '../feature-control/custom-sequence-feature-control.component';
import {ThingFeatureInterface} from '@app/app/shared/interfaces/thing/thing-feature.interface';

interface FeatureInterface extends ThingSequenceFeatureInterface {
  activeTracks?: any;
}

export interface UpdatedSequenceInterface extends UpdatedSequenceBlockInterface {
  featureId: string;
  track: number;
  segment: number;
}

@Component({
  templateUrl: './custom-sequence-feature-item.html',
  selector: 'custom-sequence-feature-item'
})

export class CustomSequenceFeatureItemComponent {
  @Input() public feature: FeatureInterface;
  @Input() public featureId: string;
  @Input() public track: number;
  @Input() public segment: number;
  @Input() public blocks: string[];
  @Input() public parkId: string;
  @Input() public id: string;
  
  @Output() updateSequence = new EventEmitter<UpdatedSequenceInterface>();

  public updateSequenceTrack(event: UpdatedSequenceBlockInterface) {
    this.updateSequence.emit({ ...event, featureId: this.featureId, track: this.track, segment: this.segment });
  }

  public values(obj: object) {
    return Object.values(obj);
  }

  public isActiveBlock(block: number): boolean | number {
    const activeBlock = this.feature.hasOwnProperty('activeTracks') ? this.feature.activeTracks.find(arr => arr['0'] === this.track && arr['1'] === this.segment && arr['2'] === block) : false;

    return !activeBlock ? false : typeof activeBlock['3'] === 'number' ? activeBlock['3'] : true;
  }

  public getName = (features: ThingFeatureInterface[]) => features[Object.keys(features)[0]].nm
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/custom-sequences/feature-item/custom-sequence-feature-item.component.ts